import { HttpRequest } from "@angular/common/http";
import {Subject} from "rxjs";

export class RequestRepeatData {

  constructor(
    public request: HttpRequest<any>,
    public observable: Subject<any>
  ) {}

}
